import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { DeltaOf, ICTGroupTransform2D } from '@tencent/slide-sdk-model';
import { canvasToEmu, emuToCanvas } from '@src/slide/infrastructure/module/independent/unit';
import _set from 'lodash/set';
import { IRect } from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

export class GroupChildFrameConverter {
    /**
     * 数据3.0转换接口
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTGroupTransform2D>>,
        uiData: IRect,
    ): void {
        if (sdkData.chOff?.x !== undefined) {
            uiData.left = emuToCanvas(sdkData.chOff?.x);
        }
        if (sdkData.chOff?.y !== undefined) {
            uiData.top = emuToCanvas(sdkData.chOff?.y);
        }
        if (sdkData.chExt?.cx !== undefined) {
            uiData.width = emuToCanvas(sdkData.chExt?.cx);
        }
        if (sdkData.chExt?.cy !== undefined) {
            uiData.height = emuToCanvas(sdkData.chExt?.cy);
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<IRect>,
        sdkData: DeltaOf<ICTGroupTransform2D>,
    ): void {
        if (uiData.left !== undefined) {
            _set(sdkData, 'chOff.x', canvasToEmu(uiData.left));
        }
        if (uiData.top !== undefined) {
            _set(sdkData, 'chOff.y', canvasToEmu(uiData.top));
        }
        if (uiData.width !== undefined) {
            _set(sdkData, 'chExt.cx', canvasToEmu(uiData.width));
        }
        if (uiData.height !== undefined) {
            _set(sdkData, 'chExt.cy', canvasToEmu(uiData.height));
        }
    }
}
